@if (initialized && interactionTypes) {
<div class="card lg:p-5 p-3">
  <h3 class="text-color mb-4">Services</h3>
  @for(interactionType of interactionTypes; track interactionType.id)  {

    @if(!interactionType.euHideInOverview) {
      <article class="flex md:align-items-center flex-column md:flex-row w-full gap-3  py-4 md:px-6 px-4 border-round border-1 surface-border mb-5 clickable-article"
               (mouseenter)="hoverId = interactionType.id"
               (mouseleave)="hoverId = null"
               [style.background]="getGradient(interactionType.id, hoverId === interactionType.id)"
               (click)="handleInteractTypeSelect(interactionType)">
        <div class="relative">
          <img [src]="interactionType.euImageUrl" alt="Abbildung" class="border-round w-full h-full md:w-8rem md:h-8rem w-6rem h-6rem">
        </div>
        <div class="flex flex-column w-full gap-2">
          <div class="flex w-full justify-content-between align-items-center">
            <p class="font-semibold text-color text-lg mt-0 mb-0 mr-3">{{interactionType.euName}}</p>

          </div>
          <p class="font-normal text-lg text-color-secondary mt-0 mb-0">{{interactionType.euDescription}}</p>
        </div>
      </article>
    }

  }
</div>
}
